import { render, staticRenderFns } from "./LinearRegression.vue?vue&type=template&id=1b1c38a9&scoped=true"
import script from "./LinearRegression.vue?vue&type=script&lang=js"
export * from "./LinearRegression.vue?vue&type=script&lang=js"
import style0 from "./LinearRegression.vue?vue&type=style&index=0&id=1b1c38a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c38a9",
  null
  
)

export default component.exports